import { isEmpty } from 'lodash';
import { useFormContext } from 'react-hook-form';
import { useCompareQuotes } from 'hooks';
import { markdownToHtml } from 'utils';
import FormEditor from 'components/hookFormComponents/FormEditor';
import { ComposeProps } from 'broker/pages/SubmissionWorkspacePage/components/NestedViews/QuoteComparisonInsights/components/types';
import { insightsFormFieldsConfig } from 'broker/pages/SubmissionWorkspacePage/components/NestedViews/QuoteComparisonInsights/form-methods/config/insightsFieldsConfig';
import { InsightsFieldsNames } from 'broker/pages/SubmissionWorkspacePage/components/NestedViews/QuoteComparisonInsights/form-methods/enums';
import { useCreateAIThread } from 'broker/pages/SubmissionWorkspacePage/hooks';
import useSubmissionsWorkspace from 'broker/pages/SubmissionWorkspacePage/store/useSubmissionWorkspace';

export default function ComparisonInsightsEditor({
  quotes,
  setInsightPopulatedByAI,
  expiringPolicyFileId,
  isDisabled,
}: ComposeProps & { isDisabled: boolean }) {
  const { compareQuotes } = useCompareQuotes();

  const { partialSubmission: submission } = useSubmissionsWorkspace();
  const { setValue, getValues } = useFormContext();

  const convertToHtml = (content: string) => markdownToHtml(content);

  const setEditorContent = (content: string) => {
    setValue(insightsFormFieldsConfig[InsightsFieldsNames.Insights].name, content);
  };

  const isEmptyQuoteInsights = isEmpty(getValues(insightsFormFieldsConfig[InsightsFieldsNames.Insights].name));
  const aiInputData = { quoteIds: quotes.map((quote) => quote.id), expiringPolicyFileId, submissionId: submission!.id };

  useCreateAIThread(
    () => compareQuotes(aiInputData),
    undefined,
    (result) => {
      if (result && isEmptyQuoteInsights) {
        const htmlContent = convertToHtml(result?.response);
        setEditorContent(htmlContent);
        setInsightPopulatedByAI({
          result: htmlContent,
          input: aiInputData,
        });
      }
    },
  );

  return (
    <FormEditor
      disabled={isDisabled}
      {...insightsFormFieldsConfig[InsightsFieldsNames.Insights]}
      excludeToolbarProps={['fontfamily']}
    />
  );
}
